import React, { Component } from 'react';
import {Button, Checkbox, Col, Row} from 'react-bootstrap';
import { handleFieldChange, handleCheckboxChange } from "../../../../Utils";
import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import Icon from '../../../../components/Icon';
import device from '../../device.config';

class Form extends Component {
    constructor(props) {
        super(props);

        if(this.props.feed) {
            const { feed } = this.props;

            this.state = {
                id: feed.id,
                name: feed.name,
                type: feed.type,
                creative: feed.creative,
                auth: feed.auth,
                factor: feed.factor,
                partnerId: `${feed.partnerId}`,
                zone: feed.zone,
                device: feed.device,
                roi: feed.roi,
                cpm: feed.cpm,
                bidfloor: feed.bidfloor,
                whitelist: feed.whitelist,
                update: true
            };
        }
        else {
            this.state = {
                id: '',
                name: '',
                type: '',
                creative: '',
                auth: '',
                partnerId: '',
                factor: '',
                zone: '',
                device: '',
                roi: '',
                cpc: '',
                whitelist: ''
            };
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleCheckboxChange = handleCheckboxChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.onSubmit(Object.assign({}, this.state));
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit} style={{ height: "auto", maxWidth: "600px" }}>
                    <FieldGroup
                        name="id"
                        label="ID:"
                        onChange={this.handleFieldChange}
                        value={this.state.id}
                        type={'number'}
                        step={'1'}
                        min={'500000'}
                        max={'510000'}
                        disabled={this.state.update}
                        required
                    />
                    <FieldGroup
                        name="name"
                        label="Name:"
                        onChange={this.handleFieldChange}
                        value={this.state.name}
                        required
                    />
                    <SelectWrap
                        value={this.state.type}
                        name="type"
                        label="Type:"
                        values={['RON', 'WL']}
                        onChange={this.handleFieldChange}
                        required
                    />
                    <SelectWrap
                        value={this.state.creative}
                        name="creative"
                        label="Creative:"
                        values={this.props.types}
                        onChange={this.handleFieldChange}
                        required
                    />
                    <FieldGroup
                        name="auth"
                        label="Auth:"
                        onChange={this.handleFieldChange}
                        value={this.state.auth}
                        required
                    />
                    <SelectWrap
                        name="partnerId"
                        label="Partner:"
                        values={this.props.partners}
                        value={this.state.partnerId}
                        onChange={this.handleFieldChange}
                        required
                    />
                    <FieldGroup
                        name="factor"
                        label="Factor:"
                        onChange={this.handleFieldChange}
                        value={this.state.factor}
                        type={'number'}
                        step={'0.01'}
                        max={'99'}
                        required
                    />
                    <SelectWrap
                        name="zone"
                        label="Zone:"
                        values={[ 'EU', 'US', 'SG' ]}
                        value={this.state.zone}
                        onChange={this.handleFieldChange}
                        required
                    />
                    <SelectWrap
                        name="device"
                        label="Device:"
                        values={device}
                        value={this.state.device}
                        onChange={this.handleFieldChange}
                        required
                    />
                    <FieldGroup
                        name="roi"
                        label="ROI:"
                        onChange={this.handleFieldChange}
                        value={this.state.roi}
                        type={'number'}
                        step={'0.01'}
                        max={'10'}
                    />
                    {
                        this.state.type === 'WL' ?
                            <FieldGroup
                                name="whitelist"
                                label="Whitelist:"
                                onChange={this.handleFieldChange}
                                value={this.state.whitelist}
                            />
                            : null
                    }

                    <Checkbox onChange={this.handleCheckboxChange} name="cpm" checked={this.state.cpm}>CPM</Checkbox>
                    <Checkbox onChange={this.handleCheckboxChange} name="bidfloor" checked={this.state.bidfloor}>BidFloor</Checkbox>
                    <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;



// WEBPACK FOOTER //
// ./src/scenes/AdkFeeds/components/Form/index.js